import React from 'react'
import { Flex, Text, Box, Image, Link } from "@chakra-ui/react";
import { AiFillGithub } from "react-icons/ai"
import { ExternalLinkIcon } from "@chakra-ui/icons"

const ProjectCard = ({title, description, tools, img, githubLink, liveLink  }) => {
    return (
        <Flex
            justifyContent="space-between"
            // border="1px solid red"
            mb="10rem"
        >
            <Box position="relative" w="40%">
                <Text mb="1rem" fontSize="1.5rem" color="primary.light">{title}</Text>
                <Text mb="1rem" color="text.dark">
                    {description}
                </Text>
                <Flex  
                    w="100%"
                    color="primary.light"
                    // border="1px solid red"
                    wrap="wrap"
                >
                    {tools.map((tool) => {
                        return <Text mr="1rem">{tool}</Text>
                    })}
                </Flex>
                <Flex
                    alignItems="center" 
                    position="absolute" 
                    left={0} 
                    bottom={5} 
                >
                    <Link
                        isExternal
                        _focus={{ textDecoration: "none" }}
                        _hover={{
                            textDecoration: "none",
                        }}
                        href={githubLink}
                    >
                        <AiFillGithub size={23} />
                    </Link>
                    <Link
                        ml="1rem"
                        isExternal
                        _focus={{ textDecoration: "none" }}
                        _hover={{
                            textDecoration: "none",
                        }}
                        href={liveLink}
                    >
                        <ExternalLinkIcon boxSize={23} />
                    </Link>
                </Flex>
            </Box>
            <Flex
                w="55%"
                justifyContent="center"
                alignItems="center"
            >
                <Image src={img} w="100%" alt="project image" />
            </Flex>
        </Flex>
    )
}

export default ProjectCard